import { useMemo } from "react"

import { Badge } from "react-bootstrap"

import SelectableItem from "../../../api/SelectableItem"

interface NotificationEditTabTitleProps {
  title: string
  icon?: JSX.Element
  items: Record<number, SelectableItem>
}
function NotificationEditTabTitle({ title, icon = undefined, items }: NotificationEditTabTitleProps) {
  const values = useMemo(() => Object.values(items || {}), [items])
  const selectedCount = useMemo(() => values.filter((v) => v.selected).length, [values])

  const badgeVariant = selectedCount === 0 ? "required" : "light"
  const badgeTitle = selectedCount > 0 ? "" : "Required at least one."
  const badgeContent = `${selectedCount}/${values.length}`

  return (
    <>
      {icon}
      <span className="initialism px-1 pr-2">{title}</span>
      <Badge variant={badgeVariant} title={badgeTitle}>
        {badgeContent}
      </Badge>
    </>
  )
}

export default NotificationEditTabTitle
